import { initializeApp } from 'firebase/app';
import {
  getFunctions,
  connectFunctionsEmulator,
  httpsCallable,
} from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
if (!firebaseConfig.projectId) {
  throw new Error(
    'Firebase Project ID is missing! Check your environment variables.'
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);

// Connect to emulator in development
if (process.env.NODE_ENV === 'development') {
  console.log('Using Firebase Functions emulator on localhost:5001');
  connectFunctionsEmulator(functions, 'localhost', 5001);
} else {
  console.log('Using production Firebase Functions');
}

const _getContentCallable = httpsCallable(functions, 'getContentCallable');
export const getContentfulData = () =>
  _getContentCallable({ mode: process.env.REACT_APP_CONTENT_MODE ?? 'delivery' });
